import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-icon-tile',
  templateUrl: './icon-tile.component.html',
  styleUrls: ['./icon-tile.component.scss'],
})
export class IconTileComponent {
  @Input() title: string;
  @Input() description: string;
  @Input() icon: string;
  @Input() iconBackgroundColor = '#56821F';
  @Input() showEllipsis = true;
  @Input() chevronColor = '#56821F';
  @Output() ellipsisClickEventEmitter = new EventEmitter();

  constructor() {}

  handleEllipsisClickEvent(event: Event) {
    this.ellipsisClickEventEmitter.emit(event);
  }
}
